import React from 'react'
import { Box, BoxProps } from '@mui/material'
import { styled } from '@mui/material/styles'

export interface FilmstripProps extends BoxProps {
  children: React.ReactNode
}

const Root = styled(Box)({
  display: 'flex',
  gap: 'var(--ds-space-3)',
  overflowX: 'auto',
  paddingBottom: 8,
  marginBottom: -4,
  scrollSnapType: 'x mandatory',
  scrollbarWidth: 'thin',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': { height: 3 },
  '&::-webkit-scrollbar-thumb': {
    background: 'var(--ds-border)',
    borderRadius: 'var(--ds-radius-pill)',
  },
  '& > *': { scrollSnapAlign: 'start', flexShrink: 0 },
})

/** Horizontal scroll row for frame / print thumbs */
export function Filmstrip({ children, ...rest }: FilmstripProps) {
  return <Root {...rest}>{children}</Root>
}
